export default __webpack_public_path__ + "static/media/image.23e3b6bf.svg";